import { useDebounce } from './use-debounce';
import { useObservable } from './use-observable';

export const useDebouncedObservable = <TValue>(valueGetter: () => TValue, delay: number): TValue => {
    const value = useObservable(valueGetter);

    return useDebounce(value, delay);
};
